import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';

import { BusinessSelectorComponent } from '../business-selector/business-selector.component';
import { ContactCardComponent } from '../contact-card/contact-card.component';
import { ContactsSelectorComponent } from '../contacts-selector/contacts-selector.component';
import { InvoiceStatusIconComponent } from '../invoice-status-icon/invoice-status-icon.component';
import { QuoteStatusIconComponent } from '../quote-status-icon/quote-status-icon.component';

import { WorkItemChooserComponent } from '../work-item-chooser/work-item-chooser.component';
import { WorkItemEditComponent } from '../work-item-edit/work-item-edit.component';
import { WorkItemAddComponent } from '../work-item-add/work-item-add.component';
import { WorkItemListComponent } from '../work-item-list/work-item-list.component';

import { ProductSearchPipe } from '../pipes/productSearchFilter.pipe';
import { PropertyChooserComponent } from '../property-chooser/property-chooser.component';
import { PropertyAddComponent } from '../property-add/property-add.component';

import { FabComponent } from './fab.component';
import { TimeagoModule } from 'ngx-timeago';

import { SafePipe } from '../safe-pipe.pipe';

// import { CurrencyServiceModule } from '../currency-service.module';

@NgModule({ declarations: [
        BusinessSelectorComponent,
        ContactCardComponent,
        ContactsSelectorComponent,
        InvoiceStatusIconComponent,
        QuoteStatusIconComponent,
        WorkItemChooserComponent,
        WorkItemEditComponent,
        WorkItemAddComponent,
        WorkItemListComponent,
        ProductSearchPipe,
        SafePipe,
        PropertyChooserComponent,
        PropertyAddComponent,
        ProductSearchPipe,
        FabComponent
    ],
    exports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        BusinessSelectorComponent,
        ContactCardComponent,
        ContactsSelectorComponent,
        InvoiceStatusIconComponent,
        QuoteStatusIconComponent,
        WorkItemChooserComponent,
        WorkItemEditComponent,
        WorkItemAddComponent,
        WorkItemListComponent,
        ProductSearchPipe,
        SafePipe,
        PropertyChooserComponent,
        PropertyAddComponent,
        ProductSearchPipe,
        FabComponent,
        TimeagoModule
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        TimeagoModule
        //CurrencyServiceModule
    ], providers: [
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class SharedModule { }
